import { render, staticRenderFns } from "./CargandoFicha.vue?vue&type=template&id=25128e45"
import script from "./CargandoFicha.vue?vue&type=script&lang=ts"
export * from "./CargandoFicha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports